/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarket,
    BrandAndMarketFromJSON,
    BrandAndMarketFromJSONTyped,
    BrandAndMarketToJSON,
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    CodeAndLabel,
    CodeAndLabelFromJSON,
    CodeAndLabelFromJSONTyped,
    CodeAndLabelToJSON,
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
    Int32IdAndLabel,
    Int32IdAndLabelFromJSON,
    Int32IdAndLabelFromJSONTyped,
    Int32IdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface GlobalFilterListConfiguration
 */
export interface GlobalFilterListConfiguration {
    /**
     * 
     * @type {Array<BrandAndMarket>}
     * @memberof GlobalFilterListConfiguration
     */
    allowedBrandsAndMarkets?: Array<BrandAndMarket> | null;
    /**
     * 
     * @type {Array<BrandAndMarketListItem>}
     * @memberof GlobalFilterListConfiguration
     */
    readonly brandsAndMarkets?: Array<BrandAndMarketListItem> | null;
    /**
     * 
     * @type {Array<Int32IdAndLabel>}
     * @memberof GlobalFilterListConfiguration
     */
    readonly distributionChannels?: Array<Int32IdAndLabel> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof GlobalFilterListConfiguration
     */
    readonly relevance?: Array<number> | null;
    /**
     * 
     * @type {Array<CodeAndLabel>}
     * @memberof GlobalFilterListConfiguration
     */
    readonly fareTypes?: Array<CodeAndLabel> | null;
    /**
     * 
     * @type {Array<GuidIdAndLabel>}
     * @memberof GlobalFilterListConfiguration
     */
    readonly suppliers?: Array<GuidIdAndLabel> | null;
}

export function GlobalFilterListConfigurationFromJSON(json: any): GlobalFilterListConfiguration {
    return GlobalFilterListConfigurationFromJSONTyped(json, false);
}

export function GlobalFilterListConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): GlobalFilterListConfiguration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'allowedBrandsAndMarkets': !exists(json, 'allowedBrandsAndMarkets') ? undefined : (json['allowedBrandsAndMarkets'] === null ? null : (json['allowedBrandsAndMarkets'] as Array<any>).map(BrandAndMarketFromJSON)),
        'brandsAndMarkets': !exists(json, 'brandsAndMarkets') ? undefined : (json['brandsAndMarkets'] === null ? null : (json['brandsAndMarkets'] as Array<any>).map(BrandAndMarketListItemFromJSON)),
        'distributionChannels': !exists(json, 'distributionChannels') ? undefined : (json['distributionChannels'] === null ? null : (json['distributionChannels'] as Array<any>).map(Int32IdAndLabelFromJSON)),
        'relevance': !exists(json, 'relevance') ? undefined : json['relevance'],
        'fareTypes': !exists(json, 'fareTypes') ? undefined : (json['fareTypes'] === null ? null : (json['fareTypes'] as Array<any>).map(CodeAndLabelFromJSON)),
        'suppliers': !exists(json, 'suppliers') ? undefined : (json['suppliers'] === null ? null : (json['suppliers'] as Array<any>).map(GuidIdAndLabelFromJSON)),
    };
}

export function GlobalFilterListConfigurationToJSON(value?: GlobalFilterListConfiguration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'allowedBrandsAndMarkets': value.allowedBrandsAndMarkets === undefined ? undefined : (value.allowedBrandsAndMarkets === null ? null : (value.allowedBrandsAndMarkets as Array<any>).map(BrandAndMarketToJSON)),
    };
}


